import { getLocalStorage, getRandomUUID, getShortUUID } from "util/CommonUtil";
import { LOCAL_STORAGE, SESSION_STORAGE } from "util/Constant";

class HelperService {
  getUserInfo() {
    try {
      const userInfo = getLocalStorage(LOCAL_STORAGE.USER_INFO);
      return userInfo ? JSON.parse(userInfo) : {};
    } catch (error) {
      console.warn("Failed to parse user info:", error);
      return {};
    }
  }

  getHostName() {
    return this.getUserInfo().hostName || "";
  }

  getExtraHeaders() {
    return this.getUserInfo().extraHeaders || {};
  }

  getHeadersWithAuth() {
    const token = this.getUserInfo().accessToken;
    return {
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      "content-type": "application/json",
      "x-host-domain": this.getHostName(),
      ...this.getExtraHeaders(),
    };
  }
  getHeadersWithAuthWithMultipartFormData() {
    const token = this.getUserInfo().accessToken;
    return {
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      "content-type": "multipart/form-data",
      "x-host-domain": this.getHostName(),
    };
  }
  getHeaders(requestId?: string, contentType = "application/json"): object {
    const token = this.getUserInfo().accessToken;
    return {
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      "content-type": "application/json",
      "x-host-domain": this.getHostName(),
      "X-REQUEST-ID":
        requestId ?? sessionStorage.getItem(SESSION_STORAGE.REQUEST_ID) ?? getShortUUID(),
      ...this.getExtraHeaders(),
    };
  }
  getAuthKey() {
    return getLocalStorage(LOCAL_STORAGE.AUTH_KEY);
  }
  getUserApiKey() {
    return getLocalStorage(LOCAL_STORAGE.USER_API_KEY);
  }
  getUserTenantId() {
    return getLocalStorage(LOCAL_STORAGE.USER_TENANT_ID);
  }
}

export default new HelperService();
